import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Checkbox, Select } from "antd";
import { PropertyOption } from "PhishingManager/pages/Step3/Step3.types";

interface Props {
    loading: boolean;
    propertyOptions: PropertyOption[];
    selectedProperties: number[];
    setSelectedProperties: (properties: number[]) => void;
    allSelected: boolean;
    setAllSelected: (val: boolean) => void;
    onPropertyDeselect: (propertyValue: number) => void;
}

const PropertySelect: React.FC<Props> = ({
    loading,
    propertyOptions,
    selectedProperties,
    setSelectedProperties,
    allSelected,
    setAllSelected,
    onPropertyDeselect,
}) => {
    const [searchValue, setSearchValue] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const filteredItems = useMemo(() => propertyOptions.filter(item => item.label.toLowerCase().includes(searchValue.toLowerCase())), [searchValue]);

    const handleSelectAll = useCallback(() => {
        if (allSelected) {
            setAllSelected(false);
            setSelectedProperties([]);
        } else {
            setAllSelected(true);
            setSelectedProperties(filteredItems.map((i) => i.value));
            setSearchValue("");
        }
    }, [allSelected, filteredItems]);

    const dropdownRender = useCallback(() => (
        <>
            <div className="group-recipients-all-option">
                <div className="group-recipients-option">
                    <Checkbox checked={allSelected} onClick={handleSelectAll}>
                        Select All
                    </Checkbox>
                </div>
            </div>

            {dropdownOpen && (
                <>
                    {filteredItems.length === 0 ? (
                        <div className="group-recipients-option">No properties found</div>
                    ) : (
                        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {filteredItems.map((el, index) => (
                            <div className="group-recipients-option" key={el.value + index}>
                                <Checkbox
                                    onClick={() => {
                                        if (selectedProperties.includes(el.value)) {
                                            setSelectedProperties(
                                                selectedProperties.filter(v => v !== el.value)
                                            );
                                            onPropertyDeselect(el.value);
                                        } else {
                                            setSelectedProperties([...selectedProperties, el.value]);
                                        }
                                    }}
                                    disabled={allSelected}
                                    checked={allSelected || selectedProperties.includes(el.value)}
                                >
                                    {el.label}
                                </Checkbox>
                            </div>
                        ))}
                        </div>
                    )}
                </>
            )}
        </>
    ), [dropdownOpen, filteredItems, allSelected, selectedProperties, searchValue, handleSelectAll]);

    useEffect(() => {
        setDropdownOpen(!loading);
    }, [loading])

    return (
        <Select
            className="phishing-step3__properties_select"
            mode="multiple"
            style={{ width: "100%" }}
            options={propertyOptions}
            placeholder="Select option"
            size="large"
            maxTagCount={0}
            showSearch={!allSelected}
            tagRender={() => <span />}
            maxTagPlaceholder={() => (
                <span>
                    {allSelected ? "All Properties" : `${selectedProperties.length} selected`}
                </span>
            )}
            value={selectedProperties}
            onSearch={(val) => setSearchValue(val)}
            onDropdownVisibleChange={(open) => {
                setDropdownOpen(open);
                if (!open) setSearchValue("");
            }}
            getPopupContainer={(trigger) => trigger.parentElement}
            dropdownRender={dropdownRender}
        />
    );
};

export default PropertySelect;